import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PasswordPersonModel, TaskResult } from '../../models/client-models';
import { AppConfig } from '../config.service';
import { HttpClient } from '@angular/common/http';

const PASSWORD_ENDPOINT = 'password';

@Injectable({
  providedIn: 'root',
})
export class PasswordBackendService {
  constructor(private http: HttpClient) {}

  /**
   * Send request to change password to backend.
   *
   * @param newPassword PersonID and Password.
   */
  updatePassword(newPassword: PasswordPersonModel): Observable<TaskResult> {
    return this.http.post<TaskResult>(
      AppConfig.settings.backend.url + PASSWORD_ENDPOINT,
      newPassword
    );
  }
}
